export default {
  notFoundTitle: "ページが見つかりません",
  notFoundContent: "お探しのページが見つかりませんでした。URLをお確かめの上再度お試しください。",
  notFoundBtn: "ダッシュボードへ戻る",
  notifyWarningTitle: "ご注意",
  notifyErrorTitle: "エラー",
  notifyInfoTitle: "提示"
};
